// extracted by mini-css-extract-plugin
export default {"customButton":"Button_customButton__mw83I","buttonIcon":"Button_buttonIcon__qf37B"};